import React from "react";
import PropTypes from "prop-types";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { DownloadOutlined } from "@ant-design/icons";

const PurchaseRequisitionPdf = ({
  pdfContainerRef,
  prNumber,
  buttonRef,
  setIsDownloading,
  downloading,
}) => {
  const downloadAsPDF = () => {
    if (!pdfContainerRef.current) {
      console.error("PDF container reference is not defined.");
      return;
    }

    setIsDownloading(true);

    if (buttonRef.current) {
      buttonRef.current.classList.add("hide-in-pdf");
    }

    window.scrollTo(0, 0);

    setTimeout(async () => {
      try {
        const container = pdfContainerRef.current;

        // Backup original styles
        const originalStyle = {
          overflow: container.style.overflow,
          width: container.style.width,
          height: container.style.height,
        };

        // Expand to full content
        container.style.overflow = "visible";
        container.style.width = "max-content";
        container.style.height = "auto";

        await new Promise((resolve) => setTimeout(resolve, 100));

        const canvas = await html2canvas(container, {
          useCORS: true,
          scale: 2,
          backgroundColor: "#ffffff",
        });

        // Restore styles
        Object.assign(container.style, originalStyle);

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("l", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgProps = pdf.getImageProperties(imgData);
        const imgRatio = imgProps.width / imgProps.height;

        let imgWidth = pdfWidth;
        let imgHeight = pdfWidth / imgRatio;

        if (imgHeight > pdfHeight) {
          imgHeight = pdfHeight;
          imgWidth = pdfHeight * imgRatio;
        }

        const x = (pdfWidth - imgWidth) / 2;
        const y = (pdfHeight - imgHeight) / 2;

        pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
        pdf.save(`Purchase Requisition_${prNumber}.pdf`);
      } catch (error) {
        console.error("Error generating PDF:", error);
      } finally {
        if (buttonRef.current) {
          buttonRef.current.classList.remove("hide-in-pdf");
        }
        setIsDownloading(false);
      }
    }, 100);
  };

  return (
    <ButtonField
      className="BlueShadowBtn"
      type="primary"
      icon={<DownloadOutlined />}
      onClick={downloadAsPDF}
      label={downloading ? "Downloading" : "Download PDF"}
      loading={downloading}
      ref={buttonRef}
    />
  );
};

PurchaseRequisitionPdf.propTypes = {
  pdfContainerRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  prNumber: PropTypes.string.isRequired,
  buttonRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  setIsDownloading: PropTypes.func.isRequired,
  downloading: PropTypes.bool.isRequired,
};

export default PurchaseRequisitionPdf;
